import connection from './connection.js'

const list = async function(callback) {
  const url = '/admin/specs/list'
  let { error, data } = await connection.query(url)
  if (callback) callback(error, data)
}

export default {
  list: list
}
